import { type GlobalStorageFile } from 'hb-react/shared/hooks/useGlobalStorageV2/types';
import { getMagicKeyUrl } from 'hb-react/shared/hooks/useGlobalStorageV2/utils';
import { getShrineId } from 'hb-react/shared/hooks/useStorage/utils';

export const buildMagicKeyUrls = (
  files: Array<GlobalStorageFile>,
  filesFieldName: string,
) =>
  files
    .filter(({ shrineKey }) => shrineKey)
    .reduce((urls, { key, shrineKey }) => {
      // @ts-expect-error shrineKey confirmed to be defined in the filter above
      const shrineId = getShrineId(shrineKey);

      // In case uploadsFieldName is a nested field like 'post[storage_uploads]'
      // we only want the last part of the string, which is the field name.
      const fieldName = filesFieldName
        .split('[')
        .splice(-1)[0]
        .replace(']', '');

      return {
        ...urls,
        [shrineKey as string]: getMagicKeyUrl({
          shrineId,
          fieldName,
        }),
        // OLD: Remove once we move Quill to use previewUrl instead of base64 previews
        [key]: getMagicKeyUrl({
          shrineId,
          fieldName,
        }),
      };
    }, {});
